import script from "./main-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./main-avatar.vue?vue&type=script&setup=true&lang=ts"

import "./main-avatar.vue?vue&type=style&index=0&id=20129648&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20129648"]])

export default __exports__